<template lang="pug">
.updated-container
  .top-word
    .top-big-word {{ afterCardInfo.name }}
    .top-small-word (已升级)
  .middle-word
    span 【{{afterCardInfo.businessId===1?'单车':'助力车'}}】
    span {{upgradeCardInfo}}
  .btn(@click="goDownload")
</template>
<script>
import { env } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { startApp } from '@/utils/index';

export default {
  props: {
    afterCardInfo: {
      type: Object,
      default: null,
    },
    upgradeCardInfo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      downloadUrl: 'https://m.hellobike.com/mf/spa/u_wsjczx/latest/MA2204243054087163443937280.html?activityCode=MA2204243054087163443937280&beyondMP=true',
    };
  },
  methods: {
    goDownload() {
      UBT.clickButton({
        pageId: 'platform_cardupdate_trans',
        buttonName: 'platform_cardupdate_download',
        categoryId: 'platform',
        businessInfo: {
          bizType: this.afterCardInfo.businessId - 1,
        },
      });
      if (env.isAliMP || env.isAliMPMonitor) {
        startApp(this.downloadUrl);
        return;
      }
      window.location.href = this.downloadUrl;
    },
  },
};
</script>
<style lang="less" scoped>
.updated-container {
  .top-word {
    display: flex;
    color: #fff;
    padding-top: 2.01rem;
    padding-left: 0.56rem;

    .top-big-word {
      font-family: Alibaba PuHuiTi, sans-serif;
      font-size: 0.25rem;
      font-weight: 900;
      line-height: 0.34rem;
    }

    .top-small-word {
      font-family: Alibaba PuHuiTi, sans-serif;
      font-size: 0.1rem;
      font-weight: 400;
      line-height: 0.48rem;
    }
  }

  .middle-word {
    margin: -0.06rem auto 0 auto;
    color: #fff;
    font-family: Alibaba PuHuiTi, sans-serif;
    font-size: 0.14rem;
    font-weight: 400;
    line-height: 0.192rem;
    width: 2.67rem;
  }

  .btn {
    background-image: url(https://m.hellobike.com/resource/helloyun/08345/j_3g_bA7oe.png?x-oss-process=image/quality,q_80);
    background-size: 100% 100%;
    width: 3.29rem;
    height: 0.67rem;
    margin: 0.69rem auto 0 auto;
  }
}
</style>
